import React, { FC } from "react";

export type ISupplierBadgesProps = {
  tourBadges: IBadgeProps[];
  size?: "base" | "sm";
};

export type IBadgeProps = {
  id: number;
  name: string;
  hex_color_code: string;
  picture_url: string;
  available: boolean;
};

export const TourBadge: FC<{
  category: IBadgeProps;
  isDisabled: boolean;
  size: "base" | "sm";
}> = ({ category, isDisabled }) => {
  return (
    <div className="flex" title={category.name}>
      <div className="flex flex-col justify-center justify-items-center items-center w-20">
        <div
          style={{
            background: isDisabled
              ? "#D9D9D9"
              : category?.hex_color_code || "gray",
          }}
          className={`flex justify-center justify-items-center rounded-full h-12 w-12 p-2`}
        >
          <img
            src={category.picture_url}
            className="text-green_bg justify-items-center flex items-center"
            alt={category.name}
          />
        </div>
        <div
          style={{ color: isDisabled ? "#D9D9D9" : "#343434" }}
          className="text-xs h-full mt-2 w-16 mx-auto text-center truncate-3"
        >
          {category.name}
        </div>
      </div>
    </div>
  );
};

export const SupplierBadges: FC<ISupplierBadgesProps> = ({
  tourBadges,
  size = "base",
}) => {
  if (tourBadges.length === 0) {
    return null;
  }
  return (
    <div>
      <div className="flex w-full overflow-x-auto overflow-y-hidden scrollbar-thin">
        {tourBadges?.map((category) => (
          <div
            key={category.id}
            className={`flex ${tourBadges.length <= 13 ? "" : "flex-1"}`}
          >
            <TourBadge
              category={category}
              size={size}
              isDisabled={!category.available}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
